export function isVisible(elem, intersectingRatio = null) {
  if (!(elem instanceof Element)) throw Error('DomUtil: elem is not an element.');
  const style = getComputedStyle(elem);
  if (style.display === 'none') return false;
  if (style.visibility !== 'visible') return false;
  if (style.opacity < 0.1) return false;
  if (
    elem.offsetWidth +
      elem.offsetHeight +
      elem.getBoundingClientRect().height +
      elem.getBoundingClientRect().width ===
    0
  ) {
    return false;
  }

  if (intersectingRatio && intersectingRatio > 0.1) {
    return true;
  }

  const elemVisibleCheckPoint = {
    x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
    y: elem.getBoundingClientRect().top + elem.offsetHeight / 2,
  };

  if (elemVisibleCheckPoint.x < 0) return false;
  if (elemVisibleCheckPoint.x > (document.documentElement.clientWidth || window.innerWidth))
    return false;
  if (elemVisibleCheckPoint.y < 0) return false;
  if (elemVisibleCheckPoint.y > (document.documentElement.clientHeight || window.innerHeight))
    return false;
  let pointContainer = document.elementFromPoint(elemVisibleCheckPoint.x, elemVisibleCheckPoint.y);
  do {
    if (pointContainer === elem) return true;
  } while ((pointContainer = pointContainer.parentNode));
  return false;
}
